import { QueryClient } from '@tanstack/react-query';
import { buildResourceListQueryKey } from './hydraPagination';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const queryKeys = {
  administrativeTypes: ['administrativeTypes'] as const,
  languages: ['languages'] as const,
  specialities: ['specialities'] as const,
  certifications: ['certifications'] as const,
  specialistTypes: ['specialistTypes'] as const,
  interventionTypes: ['interventionTypes'] as const,
  taxStatuses: ['taxStatuses'] as const,
  socialWorkerTypes: ['socialWorkerTypes'] as const,
  expertises: ['expertises'] as const,
  experiences: ['experiences'] as const,
  administratifStatus: ['administratifStatus'] as const,
  currentUser: ['currentUser'] as const,
  prospects: (route?: string) => buildResourceListQueryKey('prospects', '/prospects', route),
  companies: (route?: string) => buildResourceListQueryKey('companies', '/companies', route),
  interventions: (route?: string) => buildResourceListQueryKey('interventions', '/interventions', route),
  users: (route?: string) => buildResourceListQueryKey('users', '/users', route),
};
